import { InjectionKey, Ref } from 'vue'

import { TransportationValidationError } from '@/composables/transportation-validation'

export const validationErrorsSymbol: InjectionKey<
  Ref<Map<TransportationValidationError, string>>
> = Symbol('validationErrors')
